<ng-container *ngIf="!oldView">
    <section class="main-content wrapper content-padding availability-wrapper">
        <div class="content-panel">
    
            <div class="tabs">
                <label class="tab">
                    <a class="tab-link active-tab">Disponibilità Valet</a>
                </label>
            </div>
    
            <div class="availability-topbar">
                <div class="partner-title">
                    <h2>
                        <b>
                            VALET
                            <span *ngIf="expert" class="text-uppercase">
                            | {{expert?.user?.surname}} {{expert?.user?.name}}
                            </span>
                        </b>
                    </h2>
                    <p>Seleziona un valet per gestire la disponibilità settimanale e le eccezioni per date specifiche.</p>
                </div>
    
                <div class="partner-select-box" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))">
                    <select
                        [(ngModel)]="expertId"
                        (ngModelChange)="handleExpertChange($event)"
                    >
                        <option [ngValue]="null" disabled>Seleziona valet</option>
                        <option *ngFor="let expert of experts" [ngValue]="expert.id">{{expert?.user?.surname}} {{expert?.user?.name}}</option>
                    </select>
                </div>
            </div>
    
            <div class="availability-empty" *ngIf="!expertId">
                Seleziona un valet per gestire la disponibilità.
            </div>
    
            <app-availability-migration-card
                *ngIf="expertId && canMigrateAvailability"
                [ownerId]="expertId"
                ownerType="expert"
                (migrationCompleted)="reloadAvailabilityEditor()"
            >
            </app-availability-migration-card>
    
            <section class="availability-editor-section" *ngIf="expertId && showAvailabilityEditor">
                <app-availability-editor
                    [ownerId]="expertId"
                    ownerType="expert">
                </app-availability-editor>
            </section>
    
        </div>
    </section>
</ng-container>

<ng-container *ngIf="oldView">
    <section class="title-bar content-padding first-item">
        <div class="wrapper">
          <h2 class="left">Valet {{ (groups.includes('admin') || groups.includes('operation')) ? "Orari Apertura" : groups.includes('expert') ? "Disponibilita" : "" }} Area</h2>
          <br class="clear">
          <p><b>{{expert?.user?.surname}} {{expert?.user?.name}}</b></p>
        </div>
    </section>
    <section id="schedaConsegna" class="content-padding">
        <div class="narrow-wrapper" *ngIf="(groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader') || (groups.includes('expert') && loggedInExpert?.isTeamLeader))">
            <div>
                <label for="">Select Valet</label>
                <select name="" id="" [(ngModel)]="expertId" (ngModelChange)="handleExpertChange($event)">
                    <option [ngValue]="null" disabled selected></option>
                    <option *ngFor="let expert of experts" [ngValue]="expert.id">{{expert?.user?.surname}} {{expert?.user?.name}}</option>
                </select>
            </div>
        </div>
        <br class="clear">
        <div class="narrow-wrapper">
            <div class="bulk-add">
    
                <div class="col-48 grid-element">
                    <label for="bulkAddHanldeCheckbox"></label>
                      <label class="original-label" for="bulkAddHanldeCheckbox">
                        <input type="checkbox" id="bulkAddHanldeCheckbox" [checked]="bulkAddHanldle" (click)="toggleOnlyOne('bulkAddHanldeCheckbox')">
                            OGNI SETTIMANA [Every Week]
                      </label>
                      <label class="original-label" for="bulkEditHanldeCheckbox">
                        <input type="checkbox" id="bulkEditHanldeCheckbox"  [checked]="bulkEditHanldle" (click)="toggleOnlyOne('bulkEditHanldeCheckbox')">
                            BULK EDIT DISPONIBILITA
                      </label>
    
                      <label class="original-label" for="removeAvaCheckbox">
                        <input type="checkbox" id="removeAvaCheckbox" [checked]="removeAvaHandle" (click)="toggleOnlyOne('removeAvaCheckbox')">
                            REMOVE DISPONIBILITA
                      </label>
                </div>
    
                <form class="has-cols" [formGroup]="bulkAddForm" *ngIf="!bulkAddHanldle && !bulkEditHanldle && !removeAvaHandle" >
                    <fieldset>
                        <legend>BULK ADD DISPONIBILITA TIME:</legend>
                        <div class="grid-element-full">
                            <div>
                                <div class="offer-products">
                                    <div class="mb-5 date__time-section" style="display: flex;width: 100%;align-items: flex-end;gap: 15px;">
                                        <div class="product-q">
                                            <div class="porduct-qty">
                                                <div class="saifu-input">
                                                    <label>Start Date</label>
                                                    <input type="date" formControlName="startDate" [min]="minDate"  [max]="nextYearEnd"  (change)="onStartDateChange()">
                                                </div>
                                                <div class="saifu-input">
                                                    <label>End Date</label>
                                                    <input type="date" formControlName="endDate" [min]="minEndDate || currentYearStart"  [max]="nextYearEnd">
                                                </div>
                                                <div class="saifu-input">
                                                    <label for="">Start Time</label>
                                                    <input type="time" formControlName="startTime">
                                                </div>
                                                <div class="saifu-input">
                                                    <label for="">End Time</label>
                                                    <input type="time" formControlName="endTime">
                                                </div>
                                                <div class="col-48 grid-element">
                                                    <label for="available"></label>
                                                      <label class="original-label" for="available">
                                                        <input type="checkbox" name="available" id="available" formControlName="available">
                                                        Available
                                                      </label>
                                                </div>
                                                <div class="col-48 grid-element">
                                                    <label for="allDays"></label>
                                                    <label class="original-label" for="allDays">
                                                    <input type="checkbox" name="available" id="allDays" [(ngModel)]="allDaysCheck" (change)="checkOnlyOne('allDays')" [ngModelOptions]="{standalone: true}">
                                                        Tutti i giorni (All Days)
                                                    </label>
                                                  </div>
                                                <div class="col-48 grid-element">
                                                    <label for="monTofri"></label>
                                                    <label class="original-label" for="monTofri">
                                                    <input type="checkbox" name="available" id="monTofri" [(ngModel)]="monToFriCheck" (change)="checkOnlyOne('monToFri')" [ngModelOptions]="{standalone: true}">
                                                    Da Lunedì a Venerdì (From Monday to Friday)
                                                    </label>
                                                </div>
                                                <div class="col-48 grid-element">
                                                    <label for="weekend"></label>
                                                    <label class="original-label" for="weekend">
                                                    <input type="checkbox" name="available" id="weekend" [(ngModel)]="weekendCheck" (change)="checkOnlyOne('weekend')" [ngModelOptions]="{standalone: true}">
                                                    Solo Weekend (Only Weekend Saturday and Sunday)
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br class="clear">
                        <div class="center">
                            <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit($event.target)" [disabled]="!bulkAddForm?.valid || btnDisable">
                            Salva<i class="ml-10 far fa-save"></i>
                            </button>
                        </div>
                    </fieldset>
                </form>
    
                <form class="has-cols" [formGroup]="bulkAddForm" *ngIf="bulkAddHanldle && !bulkEditHanldle && !removeAvaHandle">
                    <fieldset>
                        <legend>BULK ADD DISPONIBILITA TIME:</legend>
                        <div class="grid-element-full">
                            <div>
                                <div class="offer-products">
                                    <div class="mb-5 date__time-section" style="display: flex;width: 100%;align-items: flex-end;gap: 15px;">
                                        <div class="product-q">
                                            <div class="porduct-qty">
                                                <div class="saifu-input">
                                                    <label>Start Date</label>
                                                    <input type="date" formControlName="startDate" [min]="minDate"  [max]="nextYearEnd"  (change)="onStartDateChange()">
                                                </div>
                                                <div class="saifu-input">
                                                    <label>End Date</label>
                                                    <input type="date" formControlName="endDate" [min]="minEndDate || currentYearStart"  [max]="nextYearEnd">
                                                </div>
                                                <div class="booking-day-container" *ngFor="let d of weekDays; let i = index">
    
                                                    <div class="col-48 grid-element">
                                                        <label></label>
                                                          <label class="original-label">
                                                            <input type="checkbox" name="available"  [(ngModel)]="days[i].available" [ngModelOptions]="{standalone: true}">
                                                            Available
                                                          </label>
                                                    </div>
                                                    
                                                    <div class="col-48 grid-element days-label-container">
                                                        <label for="{{ d }}"></label>
                                                        <label class="original-label" for="{{ d }}">
                                                            <input type="checkbox" id="{{ d }}" [(ngModel)]="days[i].selected" [ngModelOptions]="{standalone: true}">
                                                                {{ d.toUpperCase() }}
                                                        </label>
                                                    </div>
    
                                                    <div class="time-range">
                                                        <div class="pr">
                                                            <label for="{{ d }}-start">Start Time</label>
                                                            <input type="time" id="{{ d }}-start" [(ngModel)]="days[i].startTime" [ngModelOptions]="{standalone: true}">
                                                        </div>
                                                        <div class="pl">
                                                            <label for="{{ d }}-end">End Time</label>
                                                            <input type="time" id="{{ d }}-end" [(ngModel)]="days[i].endTime" [ngModelOptions]="{standalone: true}">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br class="clear">
                        <div class="center">
                            <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit($event.target)" [disabled]="!bulkAddForm?.valid">
                            Salva<i class="ml-10 far fa-save"></i>
                            </button>
                        </div>
                    </fieldset>
                </form>
    
                <form class="has-cols" [formGroup]="removeAvailabilityForm" *ngIf="!bulkAddHanldle && !bulkEditHanldle && removeAvaHandle">
                    <fieldset>
                        <legend>REMOVE DISPONIBILITA:</legend>
                        <div class="grid-element-full">
                            <div>
                                <div class="offer-products">
                                    <div class="mb-5 date__time-section" style="display: flex;width: 100%;align-items: flex-end;gap: 15px;">
                                        <div class="product-q">
                                            <div class="porduct-qty">
                                                <div class="saifu-input">
                                                    <label>Data inizio</label>
                                                    <input type="date" [min]="minDate"  [max]="nextYearEnd" formControlName="startDate">
                                                </div>
                                                <div class="saifu-input">
                                                    <label>Data Fine</label>
                                                    <input type="date" [min]="minEndDate || currentYearStart"  [max]="nextYearEnd" formControlName="endDate"> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="center">
                            <button class="btn hvr-shrink center" (click)="$event.preventDefault(); removeAvalability()" [disabled]="!removeAvailabilityForm?.valid || btnDisable">
                            Salva<i class="ml-10 far fa-save"></i>
                            </button>
                        </div>
                    </fieldset>
                </form>
    
                <div class="has-cols"  *ngIf="!bulkAddHanldle && bulkEditHanldle">
                  <fieldset style="max-height: 1000px; overflow-y: auto;">
                    <legend>BULK EDIT DISPONIBILITA TIME:</legend>
    
                    <form [formGroup]="bulkEditForm" >
                      <div class="grid-element-full">
                          <div>
                              <div class="offer-products">
                                  <div class="mb-5 date__time-section" style="display: flex;width: 100%;align-items: flex-end;gap: 15px;">
                                      <div class="product-q">
                                          <div class="porduct-qty flexnowrap">
                                              <div class="saifu-input">
                                                  <label>Data inizio</label>
                                                  <input type="date" formControlName="startDate" [min]="minDate"  [max]="nextYearEnd"  (change)="onStartDateChangeForEdit()" >
                                              </div>
                                              <div class="saifu-input">
                                                  <label>Data Fine</label>
                                                  <input type="date" formControlName="endDate"  [min]="minEndDate || currentYearStart"  [max]="nextYearEnd">
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="center">
                          <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSearch($event.target)" [disabled]="!bulkEditForm?.valid">
                          Search<i class="ml-10 far fa-save"></i>
                          </button>
                      </div>
                    </form>
    
                    <form [formGroup]="bulkEditAvailabilityTimeForm">
                      <div *ngIf="allDateKeys.length > 0;" class="grid-element-full mt-5">
                        <div >
                          <fieldset class="mt-5" style="padding: 10px;" *ngFor="let date  of allDateKeys;">
                            <legend>DATE: {{date}}</legend>
                              <div *ngFor="let time of allDateTimeforEdit[date]; let i = index">
                                <div class="offer-products">
                                  <div class="mb-5 date__time-section" style="display: flex;width: 100%;align-items: flex-end;gap: 15px;">
                                      <div class="product-q">
                                        <div class="porduct-qty flexnowrap" style="gap: 16px;">
                                            <div style="position: relative; cursor: pointer;">
                                              <i (click)="removeAvailabilityTime(date, i)" class="far fa-times-circle hvr-grow remove-product" style="position: absolute; top: 50%;left:-4px"></i>
                                            </div>
                                            <div class="saifu-input">
                                                <div>
                                                    <label for="">Ora Apertura</label>
                                                    <input type="hidden" name="id[]" [ngModelOptions]="{standalone: true}"  id="{{ 'id-' + time + '-' + i }}" [(ngModel)]="time.id">
                                                    <input
                                                    type="time"
                                                    [ngModelOptions]="{standalone: true}"
                                                    id="{{ 'startTime-' + time + '-' + i }}"
                                                    [(ngModel)]="time.startTime"
                                                    name="startTime[]">
                                                </div>
                                            </div>
                                            <div class="saifu-input">
                                                <div>
                                                    <label for="">Ora Chiusura</label>
                                                    <input
                                                    type="time"
                                                    [ngModelOptions]="{standalone: true}"
                                                    id="{{ 'endTime-' + time + '-' + i }}"
                                                    [(ngModel)]="time.endTime"
                                                    name="endTime[]">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                  </div>
                                </div>
                              </div>
                          </fieldset>
    
    
                        </div>
                      </div>
    
                      <div class="center mt-5" *ngIf="allDateKeys.length > 0;">
                        <button class="btn hvr-shrink center" id="updateBlukTime" (click)="$event.preventDefault(); onUpdate($event.target)"  [disabled]="!bulkEditAvailabilityTimeForm?.valid">
                        Update<i class="ml-10 far fa-save"></i>
                        </button>
                      </div>
                  </form>
    
                  </fieldset>
                </div>
    
            </div>
            <div class="calendar-view">
                <fieldset>
                    <legend>CALENDAR:</legend>
                    <full-calendar [options]="calendarOptions"></full-calendar>
                </fieldset>
            </div>
        </div>
    </section>
</ng-container>
